import React, { useEffect, useState, useCallback } from "react";
import api, { apiError } from "@/lib/api";
import { PageHeader } from "@/components/common";
import { Card } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";
import { useRefs, statusColor, flowColor } from "./OmsCommon";

export default function ReportHistory() {
  const refs = useRefs();
  const [rows, setRows] = useState([]);
  const [f, setF] = useState({ date_from: "", date_to: "", store_id: "", status: "" });

  const load = useCallback(async () => {
    const p = new URLSearchParams(Object.entries(f).filter(([, v]) => v)).toString();
    try { setRows((await api.get(`/oms/report-history?${p}`)).data); } catch (e) { toast.error(apiError(e)); }
  }, [f]);
  useEffect(() => { load(); }, [load]);

  return (
    <div>
      <PageHeader title="Daily Report History" subtitle="Riwayat assessment harian seluruh toko dengan status alur." />
      <div className="mb-4 flex flex-wrap gap-2">
        <label className="text-xs text-slate-500">Dari<Input type="date" value={f.date_from} onChange={(e) => setF({ ...f, date_from: e.target.value })} className="w-40" data-testid="hist-from" /></label>
        <label className="text-xs text-slate-500">Sampai<Input type="date" value={f.date_to} onChange={(e) => setF({ ...f, date_to: e.target.value })} className="w-40" data-testid="hist-to" /></label>
        <select value={f.store_id} onChange={(e) => setF({ ...f, store_id: e.target.value })} className="rounded border px-2 text-sm self-end"><option value="">Semua Toko</option>{refs.stores.map((s) => <option key={s.id} value={s.id}>{s.name}</option>)}</select>
        <select value={f.status} onChange={(e) => setF({ ...f, status: e.target.value })} className="rounded border px-2 text-sm self-end"><option value="">Semua Status</option>{["DRAFT", "SUBMITTED", "REVIEWED", "APPROVED"].map((s) => <option key={s}>{s}</option>)}</select>
      </div>
      <Card className="overflow-x-auto p-0">
        <table className="w-full text-sm">
          <thead><tr className="border-b text-left text-xs text-slate-400"><th className="p-2">Tgl</th><th>Toko</th><th>Admin</th><th className="text-right">Skor</th><th>Penilaian</th><th>Status</th><th>Dibuat</th></tr></thead>
          <tbody>
            {rows.length === 0 && <tr><td colSpan="7" className="p-6 text-center text-slate-400">Belum ada laporan.</td></tr>}
            {rows.map((r) => (
              <tr key={r.id} data-testid={`hist-row-${r.id}`} className="border-b">
                <td className="p-2">{r.date}</td><td>{r.store_name}</td><td>{r.admin || "-"}</td>
                <td className="text-right font-semibold">{r.total_score}</td>
                <td className={statusColor(r.status_label)}>{r.status_label}</td>
                <td><span className={`rounded px-2 py-0.5 text-[11px] ${flowColor(r.status)}`}>{r.status}</span></td>
                <td className="text-xs text-slate-400">{r.created_by}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </Card>
    </div>
  );
}
